var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSavings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2516_24347",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2516_24347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.65 7.7999C10.9105 7.7999 11.134 7.70824 11.3203 7.5249C11.5068 7.34157 11.6 7.11657 11.6 6.8499C11.6 6.58324 11.5062 6.35824 11.3185 6.1749C11.1309 5.99157 10.9059 5.8999 10.6435 5.8999C10.3812 5.8999 10.1555 5.99157 9.96665 6.1749C9.77776 6.35824 9.68332 6.58324 9.68332 6.8499C9.68332 7.11657 9.7781 7.34157 9.96765 7.5249C10.1573 7.70824 10.3848 7.7999 10.65 7.7999ZM4.78332 6.28324H8.64998V4.88324H4.78332V6.28324ZM2.33332 14.4166C1.93332 13.0832 1.53887 11.7525 1.14998 10.4244C0.761095 9.09629 0.56665 7.73257 0.56665 6.33324C0.56665 5.1999 0.963373 4.23324 1.75682 3.43324C2.55026 2.63324 3.51521 2.23324 4.65165 2.23324H8.39998C8.75865 1.81101 9.18776 1.48324 9.68732 1.2499C10.1869 1.01657 10.7133 0.899902 11.2667 0.899902C11.6519 0.899902 11.9843 1.03696 12.2638 1.31107C12.5435 1.58507 12.6833 1.91468 12.6833 2.2999C12.6833 2.38879 12.675 2.47212 12.6583 2.5499C12.6417 2.62768 12.6222 2.70546 12.6 2.78324C12.5667 2.87212 12.5361 2.96274 12.5083 3.05507C12.4805 3.14751 12.4555 3.24579 12.4333 3.3499L13.65 4.56657H15.4333V9.96657L13.3833 10.5999L12.25 14.4166H7.86665V13.0832H6.71665V14.4166H2.33332ZM3.52048 12.8499H5.23332V11.5166H9.33332V12.8499H11.05L12.0935 9.3689L13.85 8.81657V6.1499H12.9833L10.85 4.01657C10.8611 3.7499 10.8944 3.48601 10.95 3.2249C11.0055 2.96379 11.0722 2.6999 11.15 2.43324C10.7389 2.55546 10.3583 2.72651 10.0083 2.9464C9.65832 3.16618 9.37221 3.45624 9.14998 3.81657H4.64998C3.94409 3.81657 3.34821 4.05957 2.86232 4.54557C2.37632 5.03146 2.13332 5.62735 2.13332 6.33324C2.13332 7.45757 2.28887 8.55529 2.59998 9.6264C2.91109 10.6976 3.21793 11.7721 3.52048 12.8499Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavings);
export default __webpack_public_path__ + "static/media/savings.0103cc8a6804666eee6e4cc3ef7d365a.svg";
export { ForwardRef as ReactComponent };